export const styles = {
  wrapperCard: {
    padding: '10px',
  },
  textCenter: {
    textAlign: 'center',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientView/CampaignsBlock/styles.js